export default (targetEl, seconds, callback = () => {}) => {
    if (!targetEl || !seconds) {
        return false;
    }

    let totalSeconds = seconds;
    let timer;
    let isPaused = false;

    const updateTimerDisplay = () => {
        targetEl.innerHTML = ('0' + parseInt(totalSeconds / 60)).slice(-2) + ':' + ('0' + parseInt(totalSeconds % 60)).slice(-2);
    };

    updateTimerDisplay();

    (() => {
        timer = setInterval(() => {
            if (!isPaused) {
                --totalSeconds;
                if (totalSeconds < 0) {
                    clearInterval(timer);
                    callback();
                    return false;
                }
                updateTimerDisplay();
            }
        }, 1000);
    })();

    return {
        pause: () => {
            isPaused = true;
        },
        resume: () => {
            isPaused = false;
        },
        stop: () => {
            clearInterval(timer);
        },
        updateTimerDisplay
    };
};